import type {
  MachineCatalogApplySuggestionsPayload,
  MachineCatalogEntry,
} from '@indutrust/machine-model';
import { createCrudEvents } from '@indutrust/shared-util';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/** CRUD events for the admin machine-catalog store. */
export const adminMachineCatalogCrudEvents =
  createCrudEvents<MachineCatalogEntry>('admin-machine-catalog');

/**
 * Workflow events for admin review of catalog entries —
 * approve / reject / datasheet extraction.
 *
 * @example
 * const dispatch = injectDispatch(adminMachineCatalogWorkflowEvents);
 * dispatch.approveRequested({ id: 7 });
 */
export const adminMachineCatalogWorkflowEvents = eventGroup({
  source: 'admin-machine-catalog.workflow',
  events: {
    approveRequested: type<{ id: number }>(),
    rejectRequested: type<{ id: number; reason: string }>(),
    analyzeDatasheetsRequested: type<{ id: number }>(),
    applySuggestionsRequested: type<{
      id: number;
      payload: MachineCatalogApplySuggestionsPayload;
    }>(),
    dismissSuggestionsRequested: type<{ id: number }>(),
    pollRequested: type<void>(),
    workflowSucceeded: type<{ entry: MachineCatalogEntry }>(),
    workflowFailed: type<{ error: string }>(),
  },
});
